var map = {
	"./casino live.png": 857,
	"./casino live.svg": 858,
	"./casino.png": 859,
	"./casino.svg": 860,
	"./coupon.png": 861,
	"./coupon.svg": 862,
	"./gear.svg": 863,
	"./home.png": 864,
	"./home.svg": 865,
	"./info.svg": 464,
	"./live.png": 866,
	"./live.svg": 867,
	"./login.svg": 868,
	"./new-casino.svg": 869,
	"./new.svg": 870,
	"./oldhome.svg": 871,
	"./register.svg": 462,
	"./sport.png": 872,
	"./sport.svg": 873,
	"./virtual.png": 874,
	"./virtual.svg": 875
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 454;